import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ClientAccountProjectType } from "../../Types/HeyTraderTypes/ClientAccountTypes/ClientAccountProjectType";
import { getAllClientProjectList } from "../../Thunks/HeyTraderThunks";

interface ClientAccountSliceState {
  loader: boolean; // for refres pages and inital loadings
  clientAccountProjectList: ClientAccountProjectType[];
  errorDisplay: string | null;
}

// set inital valus
const initialState: ClientAccountSliceState = {
  loader: false,
  clientAccountProjectList: [],
  errorDisplay: "",
};

// handle api responces
const clientAccountSlice = createSlice({
  name: "clientAccountProject",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getAllClientProjectList.rejected, (state, action) => {
        state.loader = false;
        state.errorDisplay = action.error.message!;
      })
      .addCase(getAllClientProjectList.pending, (state) => {
        state.loader = true;
        state.errorDisplay = null;
      })
      .addCase(
        getAllClientProjectList.fulfilled,
        (state, action: PayloadAction<ClientAccountProjectType[]>) => {
          state.loader = false;
          state.clientAccountProjectList = action.payload;
        }
      );
  },
});

export const {} = clientAccountSlice.actions;
export default clientAccountSlice.reducer;
